export const TEXT = {
  title: 'Add Carry-up Service',
  description:
    'Carry-up Service is <b>mandatory</b> for delivery to any location above ground floor <b>without direct lift access</b>. This includes carrying furniture up any flight of stairs within apartments or landed property.',
  note: 'The Carry-up Service is required only for <b>furniture items</b> and does not need to be added on for accessory items.',
  priceMessage: '+ $50 per item, per storey',
  explanation:
    'Note: This service is limited to a maximum of 3 storeys and the weight per item must not exceed 80kg each.',
};
